import { useNavigate } from "react-router-dom";
import ImageLinks from "../../../assets/Images/ImagesLink";
import { ArrowRightFilledCircle } from "../../../assets/whiteLabelIcon";
import { useTranslation } from "react-i18next";

const FrequentCustomer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start px-5 py-5 w-full bg-white rounded-lg shadow-[0px_0px_8px_rgba(166,166,166,0.25)]">
      <div className="flex gap-1.5">
        <img
          loading="lazy"
          src={ImageLinks.icons_user}
          alt=""
          className="object-contain shrink-0 w-5 aspect-square"
        />
        <p className="font-custom text-sm font-semibold	">
          {t("frequent_deliveries")}
        </p>
      </div>
      <div
        className="mt-[6px] w-full relative"
        onClick={() => {
          navigate("/frequent-customer");
        }}
      >
        <input
          type="text"
          id="saveAddress"
          name="saveAddress"
          className="font-custom bg-gray-50 border border-accents text-dark_black text-sm font-medium rounded-[21px] w-full pt-[8px] pr-[11px] pb-[8px] pl-[24px] "
          placeholder={t("search_customer_number")}
        />
        <div
          className="absolute top-[10px] right-[10px] w-[16px] h-[16px] aspect-square"
          style={{
            opacity: 0.3,
          }}
        >
          <ArrowRightFilledCircle />
        </div>
      </div>
    </div>
  );
};

export default FrequentCustomer;
